(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[30],{

/***/ "6xug":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductFavoriteContainer; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nnm9");
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _frameworks_pop_over_PopOver__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Xzib");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("1JJ2");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");
/* harmony import */ var _ProductFavorite__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("fWEd");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;






var ProductFavoriteContainer = function ProductFavoriteContainer(_ref) {
  var displayTooltipTimeoutInMs = _ref.displayTooltipTimeoutInMs,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? '' : _ref$iconColor,
      _ref$shouldAnimateEnt = _ref.shouldAnimateEntry,
      shouldAnimateEntry = _ref$shouldAnimateEnt === void 0 ? false : _ref$shouldAnimateEnt,
      _ref$isFilled = _ref.isFilled,
      isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled,
      _ref$isNextStep = _ref.isNextStep,
      isNextStep = _ref$isNextStep === void 0 ? false : _ref$isNextStep,
      _ref$isReadyForBookin = _ref.isReadyForBookingEngine,
      isReadyForBookingEngine = _ref$isReadyForBookin === void 0 ? true : _ref$isReadyForBookin,
      isSticky = _ref.isSticky,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].STAR_HOLLOW : _ref$iconName,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? lodash_noop__WEBPACK_IMPORTED_MODULE_1___default.a : _ref$onClick,
      _ref$hasPrice = _ref.hasPrice,
      hasPrice = _ref$hasPrice === void 0 ? true : _ref$hasPrice,
      _ref$priceOfStayIsLoa = _ref.priceOfStayIsLoading,
      priceOfStayIsLoading = _ref$priceOfStayIsLoa === void 0 ? false : _ref$priceOfStayIsLoa,
      _ref$showFavoriteTool = _ref.showFavoriteTooltip,
      showFavoriteTooltip = _ref$showFavoriteTool === void 0 ? true : _ref$showFavoriteTool,
      tooltipContent = _ref.tooltipContent,
      _ref$triggerOnHover = _ref.triggerOnHover,
      triggerOnHover = _ref$triggerOnHover === void 0 ? false : _ref$triggerOnHover;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  var productFavorite = __jsx("span", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])("pointer-events-auto flex size-40 justify-center rounded-full border-1 border-lightGrey border-b-transparent border-l-transparent bg-white ".concat(isSticky ? 'mx-auto border-lightGrey' : 'mx-10', " translate-y-1/2 -rotate-45 transform duration-250 ease-in"), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, "text-".concat(iconColor), (!shouldAnimateEntry || isFilled) && isReadyForBookingEngine), {
      'translate-y-full !border-white text-white': !isReadyForBookingEngine && !isFilled || !hasPrice
    }, {
      'transition-all': isReadyForBookingEngine
    })
  }, __jsx(_ProductFavorite__WEBPACK_IMPORTED_MODULE_7__[/* ProductFavorite */ "a"], {
    className: "rotate-45",
    "data-testid": "CTA-add-remove-favorite",
    iconName: iconName,
    isDisabled: priceOfStayIsLoading,
    onClick: onClick
  }));

  if (!hasPrice) {
    return null;
  }

  return isDesktop ? __jsx("div", {
    className: "pointer-events-none absolute bottom-full duration-250 ease-in ".concat(isSticky ? 'left-1/2 -translate-x-1/2 transform' : 'end-0')
  }, isReadyForBookingEngine && hasPrice && !isFilled ? __jsx(_frameworks_pop_over_PopOver__WEBPACK_IMPORTED_MODULE_4__[/* PopOver */ "a"], {
    ariaLabel: "favorite",
    content: __jsx("div", {
      className: "w-180 p-10"
    }, tooltipContent),
    isInitiallyVisible: isReadyForBookingEngine && !isFilled && !isNextStep && showFavoriteTooltip,
    theme: isSticky ? 'favorite-centered' : 'favorite',
    timeoutInMs: displayTooltipTimeoutInMs,
    triggerOnHover: triggerOnHover
  }, productFavorite) : productFavorite) : __jsx("div", {
    className: "pointer-events-none absolute bottom-full ".concat(isSticky ? 'inset-x-0' : 'end-0')
  }, productFavorite);
};

/***/ }),

/***/ "76OQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivitiesContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // $FlowFixMe

var ActivitiesContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});

/***/ }),

/***/ "CvKO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PriceTicketFavorite; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _product_product_favorite_ProductFavoriteContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("6xug");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var PriceTicketFavorite = function PriceTicketFavorite(_ref) {
  var isFilled = _ref.isFilled,
      isNextStep = _ref.isNextStep,
      isSticky = _ref.isSticky,
      onClick = _ref.onClick;
  var iconName = isFilled ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].STAR_FILLED : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].STAR_HOLLOW;
  var iconColor = isFilled ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SUCCESS : _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLACK;
  return __jsx(_product_product_favorite_ProductFavoriteContainer__WEBPACK_IMPORTED_MODULE_4__[/* ProductFavoriteContainer */ "a"], {
    displayTooltipTimeoutInMs: 4000,
    iconColor: iconColor,
    iconName: iconName,
    isFilled: isFilled,
    isNextStep: isNextStep,
    isSticky: isSticky,
    onClick: onClick,
    tooltipContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.favoriteOption.favoriteTooltipBE.title'),
    triggerOnHover: !isFilled
  });
};

/***/ }),

/***/ "Dz6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BottomNavbarLayer_BottomNavbarLayer; });

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-dom/index.js
var react_dom = __webpack_require__("7nmT");

// CONCATENATED MODULE: /opt/webapp/node_modules/react-reverse-portal/dist/web/index.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


// Internally, the portalNode must be for either HTML or SVG elements
var ELEMENT_TYPE_HTML = 'html';
var ELEMENT_TYPE_SVG = 'svg';
// ReactDOM can handle several different namespaces, but they're not exported publicly
// https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/DOMNamespaces.js#L8-L10
var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
var validateElementType = function (domElement, elementType) {
    if (elementType === ELEMENT_TYPE_HTML) {
        return domElement instanceof HTMLElement;
    }
    if (elementType === ELEMENT_TYPE_SVG) {
        return domElement instanceof SVGElement;
    }
    throw new Error("Unrecognized element type \"" + elementType + "\" for validateElementType.");
};
// This is the internal implementation: the public entry points set elementType to an appropriate value
var createPortalNode = function (elementType, options) {
    var initialProps = {};
    var parent;
    var lastPlaceholder;
    var element;
    if (elementType === ELEMENT_TYPE_HTML) {
        element = document.createElement('div');
    }
    else if (elementType === ELEMENT_TYPE_SVG) {
        element = document.createElementNS(SVG_NAMESPACE, 'g');
    }
    else {
        throw new Error("Invalid element type \"" + elementType + "\" for createPortalNode: must be \"html\" or \"svg\".");
    }
    if (options && typeof options === "object") {
        for (var _i = 0, _a = Object.entries(options.attributes); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            element.setAttribute(key, value);
        }
    }
    var portalNode = {
        element: element,
        elementType: elementType,
        setPortalProps: function (props) {
            initialProps = props;
        },
        getInitialPortalProps: function () {
            return initialProps;
        },
        mount: function (newParent, newPlaceholder) {
            if (newPlaceholder === lastPlaceholder) {
                // Already mounted - noop.
                return;
            }
            portalNode.unmount();
            // To support SVG and other non-html elements, the portalNode's elementType needs to match
            // the elementType it's being rendered into
            if (newParent !== parent) {
                if (!validateElementType(newParent, elementType)) {
                    throw new Error("Invalid element type for portal: \"" + elementType + "\" portalNodes must be used with " + elementType + " elements, but OutPortal is within <" + newParent.tagName + ">.");
                }
            }
            newParent.replaceChild(portalNode.element, newPlaceholder);
            parent = newParent;
            lastPlaceholder = newPlaceholder;
        },
        unmount: function (expectedPlaceholder) {
            if (expectedPlaceholder && expectedPlaceholder !== lastPlaceholder) {
                // Skip unmounts for placeholders that aren't currently mounted
                // They will have been automatically unmounted already by a subsequent mount()
                return;
            }
            if (parent && lastPlaceholder) {
                parent.replaceChild(lastPlaceholder, portalNode.element);
                parent = undefined;
                lastPlaceholder = undefined;
            }
        }
    };
    return portalNode;
};
var web_InPortal = /** @class */ (function (_super) {
    __extends(InPortal, _super);
    function InPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.addPropsChannel = function () {
            Object.assign(_this.props.node, {
                setPortalProps: function (props) {
                    // Rerender the child node here if/when the out portal props change
                    _this.setState({ nodeProps: props });
                }
            });
        };
        _this.state = {
            nodeProps: _this.props.node.getInitialPortalProps(),
        };
        return _this;
    }
    InPortal.prototype.componentDidMount = function () {
        this.addPropsChannel();
    };
    InPortal.prototype.componentDidUpdate = function () {
        this.addPropsChannel();
    };
    InPortal.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, node = _a.node;
        return react_dom["createPortal"](react["Children"].map(children, function (child) {
            if (!react["isValidElement"](child))
                return child;
            return react["cloneElement"](child, _this.state.nodeProps);
        }), node.element);
    };
    return InPortal;
}(react["PureComponent"]));
var web_OutPortal = /** @class */ (function (_super) {
    __extends(OutPortal, _super);
    function OutPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.placeholderNode = react["createRef"]();
        _this.passPropsThroughPortal();
        return _this;
    }
    OutPortal.prototype.passPropsThroughPortal = function () {
        var propsForTarget = Object.assign({}, this.props, { node: undefined });
        this.props.node.setPortalProps(propsForTarget);
    };
    OutPortal.prototype.componentDidMount = function () {
        var node = this.props.node;
        this.currentPortalNode = node;
        var placeholder = this.placeholderNode.current;
        var parent = placeholder.parentNode;
        node.mount(parent, placeholder);
        this.passPropsThroughPortal();
    };
    OutPortal.prototype.componentDidUpdate = function () {
        // We re-mount on update, just in case we were unmounted (e.g. by
        // a second OutPortal, which has now been removed)
        var node = this.props.node;
        // If we're switching portal nodes, we need to clean up the current one first.
        if (this.currentPortalNode && node !== this.currentPortalNode) {
            this.currentPortalNode.unmount(this.placeholderNode.current);
            this.currentPortalNode.setPortalProps({});
            this.currentPortalNode = node;
        }
        var placeholder = this.placeholderNode.current;
        var parent = placeholder.parentNode;
        node.mount(parent, placeholder);
        this.passPropsThroughPortal();
    };
    OutPortal.prototype.componentWillUnmount = function () {
        var node = this.props.node;
        node.unmount(this.placeholderNode.current);
        node.setPortalProps({});
    };
    OutPortal.prototype.render = function () {
        // Render a placeholder to the DOM, so we can get a reference into
        // our location in the DOM, and swap it out for the portaled node.
        // A <div> placeholder works fine even for SVG.
        return react["createElement"]("div", { ref: this.placeholderNode });
    };
    return OutPortal;
}(react["PureComponent"]));
var createHtmlPortalNode = createPortalNode.bind(null, ELEMENT_TYPE_HTML);
var createSvgPortalNode = createPortalNode.bind(null, ELEMENT_TYPE_SVG);

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/bottom-navbar-layer/BottomNavbarTotalPrice.jsx
var BottomNavbarTotalPrice = __webpack_require__("EceG");

// EXTERNAL MODULE: ./src/client/components/widgets/bottom-navbar-layer/PriceTicketFavorite.jsx
var PriceTicketFavorite = __webpack_require__("CvKO");

// EXTERNAL MODULE: ./src/client/components/widgets/bottom-navbar-layer/SelectedRate.jsx
var SelectedRate = __webpack_require__("sEDY");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 5 modules
var Price = __webpack_require__("IuYR");

// CONCATENATED MODULE: ./src/client/components/widgets/bottom-navbar/BottomNavbar.jsx



var __jsx = react_default.a.createElement;












var FLEX_RATES = dist["constants"].FLEX_RATES;
var BottomNavbar_BottomNavbar = function BottomNavbar(_ref) {
  var _ref$addedServicesNum = _ref.addedServicesNumber,
      addedServicesNumber = _ref$addedServicesNum === void 0 ? 0 : _ref$addedServicesNum,
      backButton = _ref.backButton,
      children = _ref.children,
      className = _ref.className,
      isOnLastPage = _ref.isOnLastPage,
      closeButton = _ref.closeButton,
      detailsButton = _ref.detailsButton,
      forwardRef = _ref.forwardRef,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? false : _ref$hasCloseButton,
      _ref$hasPrice = _ref.hasPrice,
      hasPrice = _ref$hasPrice === void 0 ? false : _ref$hasPrice,
      hasSelectedRate = _ref.hasSelectedRate,
      _ref$isFavorite = _ref.isFavorite,
      isFavorite = _ref$isFavorite === void 0 ? false : _ref$isFavorite,
      _ref$isNextStep = _ref.isNextStep,
      isNextStep = _ref$isNextStep === void 0 ? false : _ref$isNextStep,
      _ref$isPriceLoading = _ref.isPriceLoading,
      isPriceLoading = _ref$isPriceLoading === void 0 ? false : _ref$isPriceLoading,
      navbarRef = _ref.navbarRef,
      onClickBack = _ref.onClickBack,
      onClickClose = _ref.onClickClose,
      onClickDetails = _ref.onClickDetails,
      onClickFavorite = _ref.onClickFavorite,
      price = _ref.price,
      priceSlot = _ref.priceSlot;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var isMobile = !isTablet;
  var displayInstalment = Object(i18n["d" /* getKeyValue */])('common.price.displayInstalmentsPrice') && Price["a" /* INSTALMENT_LOCALES */].includes(locale);
  var hidePriceInfo = displayInstalment && isOnLastPage;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('fixed inset-x-0 bottom-0 isolate w-full border-t-1 border-lightGrey bg-white lg:flex lg:justify-center', className),
    "data-testid": "BottomNavbar",
    ref: forwardRef
  }, onClickFavorite && __jsx(PriceTicketFavorite["a" /* PriceTicketFavorite */], {
    isFilled: isFavorite,
    isNextStep: isNextStep,
    isSticky: true,
    onClick: onClickFavorite
  }), __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative z-1 flex max-w-site flex-wrap items-center justify-between gap-4 px-20 py-5 sm:flex-nowrap md:gap-10 md:px-0 md:py-20 lg:w-full', {
      'h-[110px]': !hasSelectedRate || hidePriceInfo,
      'h-[160px]': hasSelectedRate && isMobile && !hidePriceInfo
    }),
    ref: navbarRef
  }, __jsx("div", {
    className: "hidden flex-1 lg:block"
  }, __jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, backButton, {
    className: "font-bold",
    iconLeft: {
      hasRtl: true,
      name: icons["a" /* ICONS */].ARROW_LEFT
    },
    onClick: onClickBack,
    theme: "link"
  }), backButton === null || backButton === void 0 ? void 0 : backButton.label)), hidePriceInfo ? null : hasPrice && __jsx("div", {
    className: "relative w-1/2 shrink-0 md:w-auto",
    id: "totalPriceDescription"
  }, __jsx(BottomNavbarTotalPrice["a" /* BottomNavbarTotalPrice */], {
    isLoading: isPriceLoading,
    price: price,
    hideUnit: priceSlot,
    displayInstalment: displayInstalment,
    isOnLastPage: isOnLastPage,
    className: "text-normal items-start md:items-center md:text-center"
  }), __jsx("div", {
    className: "".concat(isPriceLoading ? 'hidden' : 'block')
  }, priceSlot), Boolean(addedServicesNumber) && __jsx("span", {
    className: "absolute bottom-full end-0 z-1 inline-flex aspect-square size-30 transform items-center justify-center rounded-full bg-success p-5 text-14 font-bold text-white sm:transform-none ltr:translate-x-1/2 rtl:-translate-x-1/2"
  }, addedServicesNumber > 0 ? "+".concat(addedServicesNumber) : addedServicesNumber), hasSelectedRate && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('start-full top-[20px] mt-5 w-fit rounded-pill px-10 py-5 sm:absolute sm:mt-0 md:mx-10', {
      'bg-green': [FLEX_RATES.STANDARD, FLEX_RATES.EBB].includes(price === null || price === void 0 ? void 0 : price.selectedRate),
      'bg-sienna': (price === null || price === void 0 ? void 0 : price.selectedRate) !== FLEX_RATES.STANDARD
    })
  }, __jsx(SelectedRate["a" /* SelectedRate */], {
    price: price
  }))), !isTablet && children, __jsx("div", {
    className: "flex w-full flex-none items-center gap-10 sm:w-auto sm:flex-1 lg:justify-end"
  }, __jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, detailsButton, {
    className: "font-bold",
    iconRight: {
      name: icons["a" /* ICONS */].ARROW_DOWN
    },
    onClick: onClickDetails,
    theme: "link"
  }), detailsButton === null || detailsButton === void 0 ? void 0 : detailsButton.label), hasCloseButton && __jsx(Button["a" /* Button */], {
    className: "font-bold",
    "data-testid": closeButton === null || closeButton === void 0 ? void 0 : closeButton.dataTestId,
    onClick: onClickClose,
    theme: "link"
  }, closeButton === null || closeButton === void 0 ? void 0 : closeButton.label), isTablet && children)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/bottom-navbar-layer/BottomNavbarLayer.jsx

var BottomNavbarLayer_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */












var BottomNavbarLayer_BottomNavbarLayer = function BottomNavbarLayer(_ref) {
  var addedServicesNumber = _ref.addedServicesNumber,
      backLabel = _ref.backLabel,
      buyNowPayLaterPricing = _ref.buyNowPayLaterPricing,
      children = _ref.children,
      closeLabel = _ref.closeLabel,
      closeLayer = _ref.closeLayer,
      closeLayerLabel = _ref.closeLayerLabel,
      continueAction = _ref.continueAction,
      continueBtn = _ref.continueBtn,
      _ref$continueLabel = _ref.continueLabel,
      continueLabel = _ref$continueLabel === void 0 ? '' : _ref$continueLabel,
      forwardRef = _ref.forwardRef,
      hasSelectedRate = _ref.hasSelectedRate,
      _ref$hideContinueButt = _ref.hideContinueButton,
      hideContinueButton = _ref$hideContinueButt === void 0 ? false : _ref$hideContinueButt,
      isDisabled = _ref.isDisabled,
      isFavorite = _ref.isFavorite,
      isNextStep = _ref.isNextStep,
      isPriceLoading = _ref.isPriceLoading,
      navbarRef = _ref.navbarRef,
      nextPage = _ref.nextPage,
      onClickFavorite = _ref.onClickFavorite,
      onCloseAllLayers = _ref.onCloseAllLayers,
      openLabel = _ref.openLabel,
      overwriteContinueButton = _ref.overwriteContinueButton,
      portalPosition = _ref.portalPosition,
      previousAction = _ref.previousAction,
      previousPage = _ref.previousPage,
      isOnLastPage = _ref.isOnLastPage,
      price = _ref.price,
      shouldCloseAllLayers = _ref.shouldCloseAllLayers,
      showCloseLayerBtn = _ref.showCloseLayerBtn,
      showPanelProp = _ref.showPanel,
      toggleReceiptPanelProp = _ref.toggleReceiptPanel,
      _ref$trackClickCloseR = _ref.trackClickCloseReceipt,
      trackClickCloseReceipt = _ref$trackClickCloseR === void 0 ? noop_default.a : _ref$trackClickCloseR,
      _ref$trackClickOpenRe = _ref.trackClickOpenReceipt,
      trackClickOpenReceipt = _ref$trackClickOpenRe === void 0 ? noop_default.a : _ref$trackClickOpenRe;
  var portalNode = Object(react["useMemo"])(function () {
    return createHtmlPortalNode();
  }, []);

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isComingFromMobileApp = _useAppContext.isComingFromMobileApp;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  var _useState = Object(react["useState"])(false),
      showPanel = _useState[0],
      setShowPanel = _useState[1];

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  if (!isAppMounted) {
    return null;
  }

  var toggleReceiptPanel = function toggleReceiptPanel() {
    // toggle open
    if (!showPanel && !showPanelProp) {
      trackClickOpenReceipt();
    } else {
      trackClickCloseReceipt();
    }

    if (showPanelProp && toggleReceiptPanelProp) {
      toggleReceiptPanelProp();
    } else {
      setShowPanel(!showPanel);
    }
  };

  var closeAllLayer = function closeAllLayer() {
    closeLayer === null || closeLayer === void 0 ? void 0 : closeLayer();
    showPanel && setShowPanel(!showPanel);
  };

  if (shouldCloseAllLayers && showPanel) {
    closeAllLayer();
    onCloseAllLayers && onCloseAllLayers();
  }

  var closeLayerAndHidePanel = function closeLayerAndHidePanel() {
    setShowPanel(false);

    if (showPanelProp && toggleReceiptPanelProp) {
      toggleReceiptPanelProp();
    }
  };

  var isOpen = showPanel || showPanelProp;
  var showCloseLayerLink = showCloseLayerBtn || showPanel;
  return BottomNavbarLayer_jsx("div", {
    className: "isolate",
    "data-testid": "receipt"
  }, BottomNavbarLayer_jsx(web_InPortal, {
    node: portalNode
  }, BottomNavbarLayer_jsx(BottomNavbar_BottomNavbar, {
    addedServicesNumber: addedServicesNumber,
    backButton: {
      'aria-label': previousPage ? Object(i18n["h" /* t */])('common.backTo', {
        previousPage: previousPage
      }) : Object(i18n["h" /* t */])('common.common.previous'),
      'data-testid': 'BookingBottomNavbar-backNavigation',
      label: backLabel
    },
    className: "z-2",
    closeButton: {
      label: closeLayerLabel
    },
    detailsButton: {
      'data-testid': 'receiptbutton',
      label: isOpen ? closeLabel : openLabel
    },
    forwardRef: forwardRef,
    hasCloseButton: Boolean(showCloseLayerLink && closeLayerLabel && !isComingFromMobileApp),
    hasPrice: !!closeLayerLabel || !showPanel && !showPanelProp && !!price,
    hasSelectedRate: hasSelectedRate,
    isFavorite: isFavorite,
    isOnLastPage: isOnLastPage,
    isNextStep: isNextStep,
    isPriceLoading: isPriceLoading,
    navbarRef: navbarRef,
    onClickBack: previousAction,
    onClickClose: closeAllLayer,
    onClickDetails: toggleReceiptPanel,
    onClickFavorite: onClickFavorite,
    price: price,
    priceSlot: buyNowPayLaterPricing
  }, !overwriteContinueButton && BottomNavbarLayer_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'pointer-events-none hidden': hideContinueButton
    })
  }, continueBtn || BottomNavbarLayer_jsx(Button["a" /* Button */], {
    "aria-label": nextPage ? Object(i18n["h" /* t */])('common.continueTo', {
      nextPage: nextPage
    }) : null,
    className: "w-full",
    "data-selector": "BookingBottomNavbar-button-continue",
    "data-testid": "withA11yButtonContinue",
    isDisabled: isDisabled || isPriceLoading,
    onClick: function onClick() {
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BOTTOM_BAR, {
        detail_click: 'validate_step'
      });
      continueAction === null || continueAction === void 0 ? void 0 : continueAction();
    }
  }, continueLabel)))), BottomNavbarLayer_jsx(Portal["a" /* default */], {
    name: portalPosition
  }, BottomNavbarLayer_jsx(web_OutPortal, {
    node: portalNode
  })), isOpen && BottomNavbarLayer_jsx(Backdrop["a" /* Backdrop */], {
    closeLabel: closeLabel,
    hasCloseButton: true,
    onClose: closeLayerAndHidePanel,
    portalName: portalPosition
  }, BottomNavbarLayer_jsx("div", {
    className: "relative z-1 flex h-full w-full flex-col",
    "data-testid": "BookingBottomNavbar-receiptContainer"
  }, BottomNavbarLayer_jsx("div", {
    className: "h-[10vh] cursor-pointer",
    "data-testid": "BookingBottomNavbar-receiptDummyClose",
    onClick: closeLayerAndHidePanel
  }), BottomNavbarLayer_jsx("div", {
    className: "scrolling-touch flex flex-1 flex-col overflow-auto rounded-t-12 bg-white py-20",
    "data-testid": "price-ticket-layer"
  }, BottomNavbarLayer_jsx("div", {
    className: "grow overflow-x-hidden"
  }, children)))));
};

/***/ }),

/***/ "EceG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BottomNavbarTotalPrice; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7amT");
/* harmony import */ var _frameworks_price_Price__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("IuYR");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var BottomNavbarTotalPrice = function BottomNavbarTotalPrice(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      price = _ref.price,
      hideUnit = _ref.hideUnit,
      displayInstalment = _ref.displayInstalment,
      isOnLastPage = _ref.isOnLastPage;
  return isLoading ? __jsx(_frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__[/* Spinner */ "a"], {
    size: "small"
  }) : __jsx(_frameworks_price_Price__WEBPACK_IMPORTED_MODULE_3__[/* Price */ "b"], {
    bestPrice: price === null || price === void 0 ? void 0 : price.total,
    className: className,
    hasAsterisk: false,
    hasInitialPrice: true,
    displayInstalment: displayInstalment,
    hasTaxesAndFeesIncludedLabel: true,
    hasTotalPrice: true,
    initialPrice: price === null || price === void 0 ? void 0 : price.totalWithoutDiscount,
    isOnLastPage: isOnLastPage,
    theme: "column",
    unit: !hideUnit ? Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.priceDetails.packagePrice.totalPrice') : ''
  });
};

/***/ }),

/***/ "fWEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductFavorite; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("VHif");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;





var ProductFavorite = function ProductFavorite(_ref) {
  var className = _ref.className,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].STAR_HOLLOW : _ref$iconName,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$total = _ref.total,
      total = _ref$total === void 0 ? 0 : _ref$total,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className", "iconName", "isDisabled", "total"]);

  return __jsx("button", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('flex items-center justify-center leading-loose text-inherit', className),
    disabled: isDisabled,
    type: "button"
  }), __jsx("span", {
    className: "relative isolate flex"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    name: iconName,
    width: "1.5rem"
  }), Boolean(total) && __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__[/* Badge */ "a"], {
    className: "top-O absolute end-0 -me-10 -mt-5 size-[21px] border-white bg-success text-12 font-bold text-white",
    label: total,
    variant: "pill"
  })));
};

/***/ }),

/***/ "toM8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ReservedServicesList_ReservedServicesList; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// CONCATENATED MODULE: ./src/client/components/widgets/reserved-services-wrapper/reservedServicesUtils.js
var getMaxItemsWithoutScroll = function getMaxItemsWithoutScroll(isWinterResort, _ref) {
  var isBrowserGreaterThan = _ref.isBrowserGreaterThan;

  if (isBrowserGreaterThan.L) {
    if (isWinterResort) {
      return 2;
    }

    return 4;
  }

  if (isBrowserGreaterThan.M) {
    if (isWinterResort) {
      return 2;
    }

    return 3;
  }

  return 0;
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/context/ActivitiesContext.js
var ActivitiesContext = __webpack_require__("76OQ");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/components/widgets/reserved-services-wrapper/ServiceLine.jsx
var __jsx = react_default.a.createElement;




var ServiceLine_ServiceLine = function ServiceLine(_ref) {
  var currency = _ref.currency,
      label = _ref.label,
      noEditMode = _ref.noEditMode,
      onDelete = _ref.onDelete,
      price = _ref.price,
      services = _ref.services;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var _useState = Object(react["useState"])(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  return __jsx("li", {
    className: "flex items-baseline gap-5 leading-1"
  }, __jsx("span", {
    className: "flex-1"
  }, label), __jsx("span", {
    className: "whitespace-nowrap text-16 font-bold text-sienna"
  }, Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(price, locale, currency)), !isLoading && !noEditMode ? __jsx("button", {
    className: "h-12 shrink-0 text-20",
    "data-testid": "DeleteReservedServiceButton",
    onClick: function onClick() {
      setIsLoading(true);
      onDelete(services).catch(function (e) {
        setIsLoading(false);
        throw e;
      });
    },
    type: "button"
  }, "\xD7") : !noEditMode && __jsx(Spinner["a" /* Spinner */], {
    className: "ms-10 self-center text-current",
    size: "small"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/reserved-services-wrapper/ReservedServiceBlock.jsx





var ReservedServiceBlock_jsx = react_default.a.createElement;











var ReservedServiceBlock_ReservedServiceBlock = function ReservedServiceBlock(_ref) {
  var attendeeId = _ref.attendeeId,
      className = _ref.className,
      isAdult = _ref.isAdult,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      unicodeLastName = _ref.unicodeLastName,
      unicodeFirstName = _ref.unicodeFirstName,
      index = _ref.index,
      rentedServices = _ref.rentedServices,
      noEditMode = _ref.noEditMode,
      currency = _ref.currency;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var _useState = Object(react["useState"])(false),
      opened = _useState[0],
      setOpened = _useState[1];

  var _useContext = Object(react["useContext"])(ActivitiesContext["a" /* ActivitiesContext */]),
      deleteService = _useContext.deleteService;

  var withLoadMore = rentedServices.length > 2 && !opened;
  var total = rentedServices.reduce(function (totalPrice, _ref2) {
    var price = _ref2.price;
    return totalPrice + price;
  }, 0);

  var onDelete = function onDelete(services) {
    return deleteService(services, attendeeId);
  };

  var attendeeFirstName = (unicodeFirstName === null || unicodeFirstName === void 0 ? void 0 : unicodeFirstName.trim()) || (firstName === null || firstName === void 0 ? void 0 : firstName.trim()) || '';
  var attendeeLastName = (unicodeLastName === null || unicodeLastName === void 0 ? void 0 : unicodeLastName.trim()) || (lastName === null || lastName === void 0 ? void 0 : lastName.trim()) || '';
  var attendeelabel = "".concat(String(attendeeFirstName)).concat(attendeeFirstName ? ' ' : '').concat(String(attendeeLastName));
  return ReservedServiceBlock_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('max-w-280 text-start', className),
    "data-testid": "ReservedServiceBlock"
  }, ReservedServiceBlock_jsx(Capsule["a" /* Capsule */], {
    header: "small"
  }, ReservedServiceBlock_jsx("div", {
    className: "relative flex min-h-175 flex-col font-sans text-14"
  }, ReservedServiceBlock_jsx("header", {
    className: "label air360-replay-ignore px-10 pt-10 text-20 font-bold capitalize text-black-active",
    "data-cs-mask": true
  }, attendeelabel || (isAdult ? "".concat(Object(i18n["h" /* t */])('booking.common.adult'), " ").concat(index) : "".concat(Object(i18n["h" /* t */])('booking.common.child'), " ").concat(index))), ReservedServiceBlock_jsx("section", {
    className: "relative z-0 min-h-88 px-10 text-14",
    "data-testid": "ReservedServiceBlock--details"
  }, withLoadMore && ReservedServiceBlock_jsx("div", {
    className: "absolute z-1 h-full w-full bg-[linear-gradient(180deg,rgba(0,0,0,0),rgba(255,255,255,1)_80%)]"
  }), ReservedServiceBlock_jsx("ul", {
    className: "space-y-10"
  }, rentedServices.slice(0, 2).map(function (_ref3) {
    var price = _ref3.price,
        services = _ref3.services;
    return ReservedServiceBlock_jsx(ServiceLine_ServiceLine, {
      currency: currency,
      key: services[0].pricingInfo.id,
      label: services[0].productInfo.label,
      noEditMode: noEditMode,
      onDelete: onDelete,
      price: price,
      services: services
    });
  }), rentedServices.length > 2 && ReservedServiceBlock_jsx(lib["Collapse"], {
    isOpened: opened
  }, rentedServices.slice(2).map(function (_ref4) {
    var price = _ref4.price,
        services = _ref4.services;
    return ReservedServiceBlock_jsx(ServiceLine_ServiceLine, {
      currency: currency,
      key: services[0].pricingInfo.id,
      label: services[0].productInfo.label,
      noEditMode: noEditMode,
      onDelete: onDelete,
      price: price,
      services: services
    });
  })))), ReservedServiceBlock_jsx("footer", {
    className: "flex w-full flex-row items-end justify-between self-end border-t-1 border-grey p-10"
  }, rentedServices.length > 2 && ReservedServiceBlock_jsx("button", {
    className: "inline-flex items-center gap-2 text-12 leading-tight text-black underline hocus:text-black-active",
    onClick: function onClick() {
      return setOpened(!opened);
    },
    type: "button"
  }, !opened ? ReservedServiceBlock_jsx(react["Fragment"], null, Object(i18n["h" /* t */])('common.loadMore'), "\xA0", ReservedServiceBlock_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PLUS,
    width: "1em"
  })) : ReservedServiceBlock_jsx(react["Fragment"], null, Object(i18n["h" /* t */])('common.loadLess'), "\xA0", ReservedServiceBlock_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].MINUS,
    width: "1em"
  }))), ReservedServiceBlock_jsx("span", {
    className: "flex-1 text-right text-20 font-bold text-sienna",
    "data-testid": "ReservedServiceBlock--amount"
  }, Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(total, locale, currency))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/reserved-services-wrapper/ReservedServicesList.jsx


var ReservedServicesList_jsx = react_default.a.createElement;





var ReservedServicesList_ReservedServicesList = function ReservedServicesList(_ref) {
  var currency = _ref.currency,
      _ref$isWinterResort = _ref.isWinterResort,
      isWinterResort = _ref$isWinterResort === void 0 ? false : _ref$isWinterResort,
      _ref$noEditMode = _ref.noEditMode,
      noEditMode = _ref$noEditMode === void 0 ? false : _ref$noEditMode,
      _ref$reservedServices = _ref.reservedServicesByAttendee,
      reservedServicesByAttendee = _ref$reservedServices === void 0 ? [] : _ref$reservedServices,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      scrollForwardLabel = _ref.scrollForwardLabel;
  var responsive = Object(ResponsiveContext["b" /* useResponsive */])();
  var maxItemsWithoutScroll = getMaxItemsWithoutScroll(isWinterResort, responsive);
  return ReservedServicesList_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: scrollBackwardLabel,
    className: "-mx-5",
    forwardLabel: scrollForwardLabel,
    hasNoMouseWheelScroll: true,
    navPosition: "center"
  }, ReservedServicesList_jsx("div", {
    className: "flex ltr:flex-row rtl:flex-row-reverse gap-10"
  }, reservedServicesByAttendee.map(function (_ref2) {
    var id = _ref2.id,
        isAdult = _ref2.isAdult,
        index = _ref2.index,
        rentedServices = _ref2.rentedServices,
        firstName = _ref2.firstName,
        lastName = _ref2.lastName,
        unicodeLastName = _ref2.unicodeLastName,
        unicodeFirstName = _ref2.unicodeFirstName;
    return ReservedServicesList_jsx(ReservedServiceBlock_ReservedServiceBlock, {
      attendeeId: id,
      className: "flex-none md:flex-1 w-9/10 md:w-auto",
      currency: currency,
      firstName: firstName,
      index: index,
      isAdult: isAdult,
      key: id,
      lastName: lastName,
      noEditMode: noEditMode,
      rentedServices: rentedServices,
      unicodeFirstName: unicodeFirstName,
      unicodeLastName: unicodeLastName
    });
  }), !noEditMode && reservedServicesByAttendee.length < maxItemsWithoutScroll && Object(toConsumableArray["a" /* default */])(new Array(maxItemsWithoutScroll - reservedServicesByAttendee.length)).map(function (_, index) {
    return (// eslint-disable-next-line react/no-array-index-key
      ReservedServicesList_jsx("div", {
        key: index,
        className: "border-1 border-lightGrey border-dashed flex-none md:flex-1 h-auto rounded-12 w-9/10 md:w-auto"
      })
    );
  })));
};

/***/ })

}]);